import React from 'react';
import { Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 lg:py-28 bg-brand-blue relative overflow-hidden" data-id="element-41">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-42">
        <div className="absolute -top-[50%] -right-[10%] w-[70%] h-[150%] rounded-full bg-white blur-3xl" data-id="element-43" />
        <div className="absolute top-[20%] -left-[20%] w-[50%] h-[100%] rounded-full bg-white blur-3xl" data-id="element-44" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-45">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-46">
          Need Auto Glass Repaired Today?
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-47">
          Do not wait for a cracked windshield or broken car window to get
          worse. Request a free quote from Kosin's Glass and get help with the
          safest next step.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-48">
          <a href="#quote" className="w-full sm:w-auto bg-white text-brand-blue hover:bg-slate-50 font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-xl" data-id="element-49">
            Request a Free Auto Glass Quote
          </a>
          <a href="tel:517-545-7772" className="w-full sm:w-auto bg-transparent border-2 border-white/30 text-white hover:bg-white/10 font-bold text-lg py-4 px-8 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-50">
            <Phone className="w-5 h-5" data-id="element-51" />
            Call 517-545-7772
          </a>
        </div>
      </div>
    </section>;
}